import React, { useEffect, useRef, useState } from "react";
import { Modal, Form, Upload } from "antd";
import { Button, Input, Select, Row, Col, Spin } from "antd";
import { CloseOutlined, FormOutlined, UploadOutlined } from "@ant-design/icons";

import Axios from "../../../api/Axios";
import dayjs from "dayjs";
import { uploadFileCourse } from "../../../pages/Admin-pages/CAAdminCoursePages/courseUtils";
import { getDisplayNameFiles } from "../../icons/ApplicationColor";
const { Option } = Select;
const AddCourseStep = ({
  CreateSuccessfull,
  CreateFailed,
  id,
  onCancel,
  visible,
  type = "add",
  initialValues = null,
}) => {
  console.log(type, initialValues);
  const formRef = useRef();
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const handleCancel = () => {
    formRef.current.resetFields();
    setFileList([]);
    setUploadedFiles([]);
    setLoading(false);
    setLoading2(false);
    onCancel();
  };

  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const [cookieName, cookieValue] = cookies[i].split("=");
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }

  const csrfToken = getCookie("csrftoken");

  const onFinish = async (values) => {
    setLoading2(true);
    const additionalValues = {
      status: true,
      course: id,
      attachment: uploadedFiles.map((file) => ({ file_name: file })),
    };
    const newValues = { ...values, ...additionalValues };
    try {
      await Axios.post("/coursedetails/", newValues, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      handleCancel();
      CreateSuccessfull("New Course Step Created");
    } catch (err) {
      CreateFailed("Step Creation Failed", err);
    } finally {
      setLoading2(false);
    }
  };
  const onFinishEdit = async (values) => {
    setLoading2(true);
    const additionalValues = {
      status: true,
      course: id,
      id: initialValues?.id,
      attachment: uploadedFiles.map((file) => ({ file_name: file })),
    };
    const newValues = { ...values, ...additionalValues };
    try {
      await Axios.put(`/coursedetails/?id=${initialValues?.id}`, newValues, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      handleCancel();
      CreateSuccessfull("Edit Course Step Created");
    } catch (err) {
      CreateFailed("Step Edit Failed", err);
    } finally {
      setLoading2(false);
    }
  };
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [fileList, setFileList] = useState([]);

  const handleUpload = async (file) => {
    setLoading(true);
    const file_name = await uploadFileCourse(
      file,
      "coursedetails",
      csrfToken,
      true,
      id
    );
    setUploadedFiles((prevFiles) => [...prevFiles, file_name]);
    setLoading(false);
  };

  const handleChange = async (info) => {
    // Find newly added files by comparing with previous fileList
    const newFiles = info.fileList.filter(
      (file) =>
        !fileList.some((f) => f.uid === file.uid) &&
        file.originFileObj &&
        !uploadedFiles.includes(file.name)
    );

    // Upload each new file
    for (const file of newFiles) {
      await handleUpload(file.originFileObj);
    }

    // Always sync fileList with AntD's internal state
    setFileList(info.fileList);
  };
  const handleRemove = (file) => {
    console.log(file);
    const removedUid = file.uid;

    // Remove from fileList
    setFileList((prevList) =>
      prevList.filter((item) => item.uid !== removedUid)
    );
    // Remove UID from uploadedFiles array
    setUploadedFiles((prevFiles) =>
      prevFiles.filter((uid) => uid !== removedUid)
    );
    return true; // allow removal
  };
  const mapAttachmentsToFileList = (attachments) => {
    if (!attachments) return [];
    return attachments.map((file, idx) => ({
      uid: file.file_name || idx, // unique id, can use file_name or idx
      // name: file.file_name.split("/").pop(), // extract file name
      name: getDisplayNameFiles(file.file_name.split("/").pop()),
      status: "done",
      url: file.url,
      file_name: file.file_name, // keep for uploadedFiles
    }));
  };
  useEffect(() => {
    const loadForm = () => {
      if (formRef.current && initialValues && visible) {
        formRef.current.setFieldsValue({
          name: initialValues?.name,
          description: initialValues?.description,
          type: initialValues?.type,
        });
        const mapped = mapAttachmentsToFileList(initialValues.attachment || []);
        setFileList(mapped);
        setUploadedFiles(mapped?.map((f) => f.file_name));
      }
    };
    loadForm();
  }, [initialValues, visible]);
  return (
    <Modal
      open={visible}
      onCancel={handleCancel}
      footer={null}
      title={
        <p className="modal-heading">
          {type === "add" ? "Add New Course Step" : "Edit Course Step"}
        </p>
      }
      centered
      width={700}
      style={{ zIndex: 1000 }}
    >
      <Form
        name="complex-form"
        onFinish={type === "add" ? onFinish : onFinishEdit}
        layout="vertical"
        ref={formRef}
        initialValues={{
          purchased_at: dayjs(),
        }}
        labelCol={{ span: 25 }}
        wrapperCol={{ span: 80 }}
        style={{ width: "100%" }}
      >
        <div className="group1" style={{ padding: "0rem" }}>
          <div className="antd-test-client" style={{ marginTop: "2rem" }}>
            <Row gutter={20} style={{ marginLeft: "2rem" }}>
              <Col xs={24} sm={12} md={10} lg={10} xl={10}>
                <Form.Item label={<p className="my-form-lables">Step Name</p>}>
                  <Form.Item
                    name="name"
                    noStyle
                    rules={[{ required: true, message: "Name is required" }]}
                  >
                    <Input.TextArea
                      placeholder="Enter Step Name"
                      name="name"
                      className="my-form-input-antd-test"
                    />
                  </Form.Item>
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={10} lg={14} xl={14}>
                <Form.Item
                  label={<p className="my-form-lables">Description</p>}
                >
                  <Form.Item name="description">
                    <Input.TextArea
                      placeholder="Enter your description"
                      name="description"
                      className="my-form-input-antd-test"
                    />
                  </Form.Item>
                </Form.Item>
              </Col>
            </Row>
          </div>

          <div className="antd-test-client">
            <Row gutter={20} style={{ marginLeft: "2rem" }}>
              <Col xs={24} sm={12} md={10} lg={10} xl={10}>
                <Form.Item label={<p className="my-form-lables">Step Type</p>}>
                  <Form.Item
                    noStyle
                    name="type"
                    rules={[{ required: true, message: "Type is required" }]}
                  >
                    <Select
                      placeholder="Select Status"
                      className="my-form-input-antd-test"
                    >
                      <Option value="TASK">Task</Option>
                      <Option value="TESTING">Testing</Option>
                      <Option value="PREPARATION">Preparation</Option>
                      <Option value="REINFORCEMENT">Reinforcement</Option>
                    </Select>
                  </Form.Item>
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={10} lg={14} xl={14}>
                <Form.Item
                  label={<p className="my-form-lables">File Upload</p>}
                >
                  <Form.Item
                    noStyle
                    name="attachment"
                    style={{ width: "100%" }}
                  >
                    <Spin spinning={loading}>
                      <Upload
                        name="attachment"
                        listType="text"
                        beforeUpload={() => false}
                        style={{ width: "100%" }}
                        onChange={handleChange}
                        onRemove={handleRemove}
                        multiple={true}
                        loading={loading}
                        customRequest={({ file }) => {}}
                        fileList={fileList}
                        accept=""
                      >
                        <Button
                          icon={<UploadOutlined />}
                          style={{ width: "315px" }}
                        >
                          Click to Upload
                        </Button>
                      </Upload>
                    </Spin>
                  </Form.Item>
                </Form.Item>
              </Col>
            </Row>
          </div>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            height: "2rem",
            marginTop: "1rem",
            marginBottom: "1rem",
          }}
        >
          <Form.Item style={{ marginRight: "1rem" }}>
            <Button key="back" onClick={handleCancel}>
              <CloseOutlined /> Cancel
            </Button>
          </Form.Item>
          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              style={{ background: "#f58029" }}
              className="save-update-btn"
              loading={loading2}
            >
              {type === "add" ? "Save" : "Update"}
              <FormOutlined />
            </Button>
          </Form.Item>
        </div>
      </Form>
    </Modal>
  );
};

export default AddCourseStep;
